import { getPlatform, isNativePlatform } from './capacitor';

const STORAGE_KEY = 'mobile_device_id';

function generateDeviceId() {
  const randomPart = Math.random().toString(36).slice(2, 12);
  return `ems-${getPlatform()}-${Date.now()}-${randomPart}`;
}

export async function getOrCreateMobileDeviceId() {
  if (!isNativePlatform()) {
    return null;
  }

  const existing = localStorage.getItem(STORAGE_KEY);
  if (existing) {
    return existing;
  }

  const nextId = generateDeviceId();
  localStorage.setItem(STORAGE_KEY, nextId);
  return nextId;
}

export function getStoredMobileDeviceId() {
  if (!isNativePlatform()) {
    return null;
  }

  return localStorage.getItem(STORAGE_KEY);
}
